import { render, staticRenderFns } from "./DemoCustomers.vue?vue&type=template&id=3d42432f&scoped=true"
import script from "./DemoCustomers.vue?vue&type=script&lang=js"
export * from "./DemoCustomers.vue?vue&type=script&lang=js"
import style0 from "./DemoCustomers.vue?vue&type=style&index=0&id=3d42432f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d42432f",
  null
  
)

export default component.exports